import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-right-ticket d-flex justify-content-center align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "mx-2"
}

import { InterfacesColor, InterfaceId } from "@/types/tickets";
import { Interfaces } from "../../types/tickets";

export default /*#__PURE__*/_defineComponent({
  props: {
    timestamp: null,
    socialNetwork: null,
    pinned: { type: Boolean },
    lastMessageClient: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	timestamp: string;
	socialNetwork?: Interfaces | "webchat";
	pinned?: boolean | false;
	lastMessageClient?: boolean | false;
	/* 		| "twitter"
		| "facebook"
		| "instagram"
		| "whatsapp"
		| "webchat"
		| "email"; */
}


function staticIconForInterface(int: InterfaceId) {
	return Interfaces[int] === Interfaces.IMAP_SMTP_EMAIL;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(__props.lastMessageClient ? `text-${_unref(InterfacesColor)[props.socialNetwork as InterfaceId]} font-weight-bold` : '')
    }, _toDisplayString(props.timestamp), 3),
    _createElementVNode("span", {
      class: _normalizeClass(`ticket-icon ${staticIconForInterface(props.socialNetwork as InterfaceId) ? 'no-rotate' : ''}`)
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(`${_unref(Interfaces)[props.socialNetwork as InterfaceId]}` +  (__props.lastMessageClient ? ` text-${_unref(InterfacesColor)[props.socialNetwork as InterfaceId]}` : ''))
      }, null, 2)
    ], 2),
    (props.pinned)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("i", {
            class: _normalizeClass('fas fa-thumbtack' +  (__props.lastMessageClient ? ` text-${_unref(InterfacesColor)[props.socialNetwork as InterfaceId]}` : ''))
          }, null, 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})